import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PageNotFound() {
    const { t } = useTranslation();
    return (
        <div
            className={'margin flex min-h-[calc(100vh-73px)] flex-col items-center justify-center'}>
            <h1 className={'font-montserrat text-8xl font-medium'}>404</h1>
            <h2 className={'text-center'}>{t('translation:PAGE_NOT_FOUND.SLOGAN')}</h2>
            <Link to={'/'}>
                <button className={'btn-filled mt-2 bg-SM-yellow text-white ring-SM-yellow/50'}>
                    {t('translation:PAGE_NOT_FOUND.BACK_TO_HOME')}
                </button>
            </Link>
        </div>
    );
}
